@if (!message.codalt || (Roles.Codalt | hasRole)) {
    <div class="message" [ngClass]="message.ai ? 'bot' : 'user'">
        <div class="message-content">
            <div class="bubble">
                @if (message.created_at) {
                    <div class="message-time">
                        {{ message.created_at | relativeTime }}
                    </div>
                }
                @if (message.codalt && (Roles.Codalt | hasRole)) {
                    <div class="codalt-message">
                        <strong>Bericht voor/van Codalt</strong>
                    </div>
                }
                <div [innerHTML]="message.message | mention: users : roles"></div>
                @if (message.query && (Roles.Codalt | hasRole)) {
                    <div class="sql-query-toggle">
                        <button
                            class="query-toggle-btn"
                            [class.active]="isQueryVisible"
                            (click)="toggleQueryVisibility(message.id)"
                            title="Toon/verberg SQL query">
                            <i class="fas fa-database"></i>
                            <span>{{ isQueryVisible ? 'Verberg SQL' : 'Toon SQL' }}</span>
                        </button>
                    </div>
                }
                <!-- Show SQL query when toggled on -->
                @if (message.query && (Roles.Codalt | hasRole) && isQueryVisible) {
                    <div class="sql-query-container">
                        <div class="sql-query-header">
                            <i class="fas fa-database"></i>
                            <strong>SQL Query:</strong>
                        </div>
                        <pre class="sql-query">{{ message.query }}</pre>
                    </div>
                }
                @if (message.results) {
                    @if (isTableData(message.results)) {
                        <div class="results-table-container">
                            <table class="table table-striped table-sm mt-2">
                                <thead>
                                    <tr>
                                        @for (header of getTableHeaders(message.results); track header) {
                                            <th
                                                class="sortable-header"
                                                [class.text-right]="(header | tableTitle).isNumeric"
                                                (click)="sortTable(message, header)">
                                                <span>{{ (header | tableTitle).title }}</span>
                                                <app-sorting-icon
                                                    [currentSort]="getTableSortState(message).currentSort"
                                                    [desc]="getTableSortState(message).desc"
                                                    [property]="header">
                                                </app-sorting-icon>
                                            </th>
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (row of getSortedTableRows(message); track row.id) {
                                        <tr>
                                            @for (header of getTableHeaders(message.results); track header) {
                                                <td
                                                    [class.text-right]="
                                                        (row[header] | isNumeric) ||
                                                        (header | tableTitle).isNumeric ||
                                                        isDateTimeFormat(row[header])
                                                    ">
                                                    <div
                                                        [innerHTML]="
                                                            row[header]
                                                                | aiDynamicCellContent: row : header : projectClicked
                                                        "></div>
                                                </td>
                                            }
                                        </tr>
                                    }
                                    @if (message.paginatedResults && message.paginatedResults.has_more) {
                                        <tr class="curpoint" (click)="onLoadMoreResults()">
                                            <td
                                                class="text-center"
                                                [attr.colspan]="getTableHeaders(message.results).length">
                                                En nog {{ message.paginatedResults.hidden_count }} andere resultaten
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    } @else {
                        <p>Er lijken geen resultaten te zijn. Probeer het op een andere manier.</p>
                        @if (Roles.Codalt | hasRole) {
                            <pre class="results-json mt-2">{{ message.results | json }}</pre>
                        }
                    }
                }
            </div>
            <!-- Message actions below bubble -->
            @if (message.results && isTableData(message.results)) {
                <div class="message-actions">
                    <button
                        class="action-btn"
                        [disabled]="message.loadingExcel"
                        (click)="exportMessageToExcel(message)"
                        title="Exporteer tabel naar Excel">
                        <i class="fas fa-file-excel"></i>
                    </button>
                </div>
            }
        </div>
    </div>
}
